import React from 'react'
import { styles } from './styles'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'

const useStyles = makeStyles(styles)

//TODO maybe extract this with a container to reuse in other components
const ScrollCaret = ({ orientation, onClick }) => {
    const classes = useStyles()
    return (
        <div onClick={onClick} className={clsx(classes.caret, classes[orientation || 'left'])}>
            <FontAwesomeIcon className={classes.caretIcon} icon={faAngleLeft} />
        </div>
    )
}

ScrollCaret.propTypes = {
    orientation: PropTypes.oneOf(['left', 'right']),
}

export default React.memo(ScrollCaret)
